import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__ from "../useEventListener/index.js";
const MF_REDUX_ACTION_EVENT = '@ovpn-mf-redux-action';
function useMfReduxActionDispatcher(dispatch, currentDispatcher, ignoredActions) {
    const handleExternalAction = (0, __WEBPACK_EXTERNAL_MODULE_react__.useCallback)(({ detail })=>{
        var _detail_action_meta, _detail_action;
        const dispatcher = null == detail ? void 0 : null === (_detail_action = detail.action) || void 0 === _detail_action ? void 0 : null === (_detail_action_meta = _detail_action.meta) || void 0 === _detail_action_meta ? void 0 : _detail_action_meta.dispatcher;
        if (dispatcher && dispatcher !== currentDispatcher) {
            if (!(null == ignoredActions ? void 0 : ignoredActions.includes(detail.action.type))) dispatch(detail.action);
        }
    }, [
        dispatch,
        currentDispatcher,
        ignoredActions
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE__useEventListener_index_js_66e788f5__.useEventListener)(MF_REDUX_ACTION_EVENT, handleExternalAction);
}
function makeMfReduxActionHandlers(dispatcher, dispatchedActions = []) {
    const matchAction = (action)=>{
        var _action_meta;
        return !(null === (_action_meta = action.meta) || void 0 === _action_meta ? void 0 : _action_meta.dispatcher) && dispatchedActions.includes(action.type);
    };
    function dispatchEventSaga(action) {
        const eventDetails = {
            detail: {
                action: {
                    ...action,
                    meta: {
                        dispatcher,
                        ...action.meta
                    }
                }
            }
        };
        const event = new CustomEvent(MF_REDUX_ACTION_EVENT, eventDetails);
        window.dispatchEvent(event);
    }
    return [
        matchAction,
        dispatchEventSaga
    ];
}
export { MF_REDUX_ACTION_EVENT, makeMfReduxActionHandlers, useMfReduxActionDispatcher };
